<!--仓库发起采购页面--镜架-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 98%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="120">
            <span v-if="noeditpage">{{controlData.cangkuname}}</span>
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename" v-else>
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right"  width="80">类&nbsp;&nbsp;别：</td>
          <td  width="160">
            <span v-if="noeditpage">{{form.seedname}}</span>
            <CommonTree ref="treeSeed" v-else :inputSize="'mini'" :defineDataSource="true" @bindData="bindData" :selectpingpai="true"
                        :treeWidth="450"
                        :onlyShowGroupType="false" :needTopNode="false" :onlySelectChild="true"
                        :treeHeight="300" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </td>
          <td colspan="2">{{pingpainame==form.seedname?'':pingpainame}}</td>
        </tr>
        <tr class="noborder" v-if="!noeditpage && !frombuy && form.seedcode">
          <td align="right">扫&nbsp;&nbsp;&nbsp;&nbsp;码：</td>
          <td colspan="4">
            <el-input v-model="scanbarcode" size="mini" ref="scanbarcode" placeholder="请扫镜架唯一码"
                      style="width: 300px;" onfocus="this.select()"
                      @keyup.enter.native="handleScanBarcode"></el-input>
          </td>
        </tr>
        <tr class="noborder" style="display: none">
          <td align="right">订单号：</td>
          <td>系统自动生成</td>
          <td align="right">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <td>{{controlData.adddate}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">供应商：</td>
          <td >
            <el-select v-model="pcustomerserial" placeholder="请选择" size="mini" @change="changepcu">
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
          </td>
          <td align="right" v-if="!ssotoken">供应号：</td>
          <td v-if="!ssotoken">
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号"
                      onfocus="this.select()"></el-input>
          </td>
          <td align="right" width="80">跟踪号：</td>
          <td>
            <el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请填写跟踪单号" style="width: 160px"
                      onfocus="this.select()"
            ></el-input>
          </td>
          <!--<td align="right" width="80">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</td>-->
          <!--<td width="220">{{controlData.caddress}}</td>-->
          <!--<td align="right" width="60">联系人&nbsp;&nbsp;&nbsp;:</td>-->
          <!--<td width="140">{{controlData.clinkman!=null ||-->
            <!--controlData.clinkmantel!=null?controlData.clinkman+controlData.clinkmantel:" "}}-->
          <!--</td>-->
        </tr>
        <tr class="noborder">
          <td></td>
          <td></td>
          <td></td>
          <td>总数:{{totalnumber}}</td>
          <td></td>
          <td style="padding-left: 60px" v-if="!enableddetail">
            &nbsp;&nbsp;<a href="./static/file/镜架导入模板.xlsx" >导入模板</a>&nbsp;&nbsp;&nbsp;
            <el-button type="warning" v-on:click="jingjiaupload" size="mini">导 入</el-button>
            <el-button size="mini" type="success" @click.stop.prevent="addGood()">增加</el-button>
            <el-button size="mini" type="success" @click.stop.prevent="showGoodDetailSel()">选择
            </el-button>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>

              <el-table-column
                prop="seedcode"
                label="编码"
                align="center" :show-overflow-tooltip="true"
                width="100"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="seedname" :show-overflow-tooltip="true"
                label="名称"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="model"
                label="型号"
                width="100"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="color"
                label="色号"
                width="100"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                :label="isReturnOrder ? '退货数量' : '数量'"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <span v-if="enableddetail">{{scope.row.totalnumber}}</span>
                  <el-input style="width: 100%" size="small" v-else v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @change="handleNumberChange(scope.row)"></el-input>
                </template>
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="barcodes"-->
                <!--label="扫码"-->
                <!--align="left"  width="100"-->
                <!--header-align="center">-->
                <!--<template slot-scope="scope">-->
                  <!--<el-input style="width: 80%" size="mini" v-model="scope.row.onlycode"-->
                            <!--:ref="'code'+scope.row.id"-->
                            <!--onfocus="this.select()"-->
                            <!--@keyup.down.native="validateCounts(scope.row,scope.$index, $event,'code')"-->
                            <!--@keyup.up.native="validateCounts(scope.row,scope.$index, $event,'code')"-->
                            <!--@change="selectonlyonecode(scope.row)"></el-input>-->
                  <!--<div v-for="item in scope.row.barcodes" :key="item.storegoodsbarcode">-->
                    <!--{{item.storegoodsbarcode}}&nbsp;&nbsp;&nbsp;<i class="el-icon-close" style="cursor: pointer" @click="clearBar(item.storegoodsbarcode,scope.row)"></i>-->
                  <!--</div>-->
                <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column label="操作" align="center" width="130" v-if="!enableddetail">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 40px" v-model="controlData.remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button type="success" @click="savePrint(true)" v-if="!frombuy" :loading="loading">提交&打码</el-button>
      <el-button type="primary" @click="savePrint(false)" :loading="loading">提交</el-button>
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
    </div>
    <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
    <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode"></BatchBuyFormProperties>
    <BuyfromSupplyer ref="BuyfromSupplyer"></BuyfromSupplyer>
    <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelect"></MakeInventoryFrameAdd>
    <QRCodeCreate ref="QRCodeCreate1"></QRCodeCreate>
  </el-dialog>
</template>


<script>

  import {suppliers} from '@/api/set/externaldept';
  import {saveData as saveLogData} from '@/api/set/handlelog';
  import {sortByKey} from '@/api/dateUtil';
  import {checkModuleRight} from '@/api/login'
  import BuyfromSupplyer from '../buyagreement/BuyfromSupplyer';
  import {login, createOrder,backOrder} from '@/api/ossi';
  import {getRemark} from '@/plugin/ordercommon'
  import BatchBuyFormProperties from '../buyagreement/BatchBuyFormProperties'
  import {buyodersavedetail, SSOrelatedOrder, updatebuyorder} from '@/api/set/csagreement';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getQRCode as getBarDetail} from '@/api/set/jxcstoregoodsbar'
  import {listgoodsframe, getDetail, getGoodsTree,jingjiaupload} from '@/api/set/jxcgooddetail'
  import {loadSpecFrame} from '@/plugin/ordercommon'
  import {weiyimalist} from '@/api/set/jxcstoregoodsbarcode';
  import MakeInventoryFrameAdd from '../../warehouse/MakeInventoryFrameAdd';
  import QRCodeCreate from './QRCodeCreate';

  export default {
    name: 'BatchBuyorderDetailEdit',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        isReturnOrder: false, //是否为采购退货模式
        frombuy:false,
        ssotoken:"",
        website:"",
        userInfoModel: {},
        data: '2',
        didata: '',
        framebuyordernoaudit:'',
        noeditpage:false,
        enableddetail:false,
        relationserial:'',
        iddata: '',
        showQRCode:false,
        dialogFormVisible: false,
        title: "",
        index: -99,
        seedgoods: [],
        subnumber:0,
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        maxyear: yearnow,
        maxmonth: monthnow,
        remark: '',
        tableData: [
          {column: []},
        ],
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {},
        showtitle1: "none",
        jxcstoreData: [],
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo: "",
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        seedcodeData: [],//选择类别后的商品
        seedcodes: '',
        pingpainame:'',
        tableData: [],
        loading: false,//防止多次提交
        totalnumber: 0,
        pcustomerserial: '',
        scanbarcode: ''//扫码入库的唯一码
        ,needAudit: true//是否需要采购审核（auditbuyorder未配置则不需要审核，直接入库）
      }

    },
    methods: {
      addGood(){
        this.$refs.MakeInventoryFrameAdd.show(this.seedcodeData,{cangkucode:this.controlData.cangkucode,cangkuname:this.controlData.cangkuname})
      },
      guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      //回车跳入下一行
      validateCounts(row, index, e ,pre) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[pre+row.id].blur()
          if (this.tableData.length - 1 === index) {
            index = -1
          }
          this.$refs[pre + (index + 1)].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[pre+row.id].blur()
          if (index === 0) {
            index = this.tableData.length
          }
          this.$refs[pre + (index - 1)].focus();
        }
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      selectonlyonecode(item) {
        for (let i in this.tableData) {
          for (let j in this.tableData[i].barcodes) {
            if (this.tableData[i].barcodes[j].storegoodsbarcode == item.onlycode) {
              item.onlycode = "";
              this.$message({
                message: '唯一码重复！',
                type: 'error'
              })
              return;
            }
          }
        }
        item.barcodes.push({
          storegoodsbarcode: item.onlycode
        });
        item.totalnumber=item.barcodes.length;
        item.onlycode=''
        this.totalNumber()
        // weiyimalist({storegoodsbarcode: item.onlycode}).then(response => {
        //   if (response.data.code == 0) {
        //
        //   }
        // })
      },
      clearBar(storegoodsbarcode,item) {
        for (let i in item.barcodes) {
          if (item.barcodes[i].storegoodsbarcode == storegoodsbarcode) {
            item.barcodes.splice(i, 1)
            break;
          }
        }
        item.totalnumber=item.barcodes.length
        this.totalNumber()
      },
      //扫码入库：扫镜架唯一码后自动获取商品信息并加入列表
      handleScanBarcode() {
        let code = (this.scanbarcode || '').trim()
        if (!code) {
          return
        }
        //检查是否重复扫码
        for (let i in this.tableData) {
          for (let j in this.tableData[i].barcodes) {
            if (this.tableData[i].barcodes[j].storegoodsbarcode == code) {
              this.$message({ message: '该唯一码已扫入，请勿重复扫码！', type: 'warning' })
              this.scanbarcode = ''
              this.$nextTick(() => { this.$refs.scanbarcode.focus() })
              return
            }
          }
        }
        getBarDetail({ storegoodsbarcode: code }).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            let obj = response.data.obj
            let packagesize = {}
            try {
              packagesize = JSON.parse(obj.packagesize || '{}')
            } catch (e) {
              packagesize = {}
            }
            let model = packagesize.M || ''
            let color = packagesize.C || ''
            if (!obj.seedcode || !model) {
              this.$message({ message: '未扫到商品信息，请检查条码！', type: 'warning' })
              this.scanbarcode = ''
              this.$nextTick(() => { this.$refs.scanbarcode.focus() })
              return
            }
            //查找已有同seedcode+型号+色号的行，有则数量+1并追加条码
            let found = false
            for (let j in this.tableData) {
              if (this.tableData[j].seedcode == obj.seedcode && this.tableData[j].model == model && this.tableData[j].color == color) {
                this.tableData[j].totalnumber++
                this.tableData[j].barcodes.push({ storegoodsbarcode: code })
                found = true
                break
              }
            }
            if (!found) {
              this.tableData.push({
                seedcode: obj.seedcode,
                seedname: obj.seedname || '',
                color: color,
                model: model,
                categorycode: this.form.seedcode || '',
                totalnumber: 1,
                formproperty: '[{}]',
                packagesize: obj.packagesize || '{}',
                onlycode: '',
                barcodes: [{ storegoodsbarcode: code }]
              })
            }
            this.sortTable()
            this.totalNumber()
            this.$message({ message: '扫码成功：' + (obj.seedname || code), type: 'success' })
          } else {
            this.$message({ message: '未扫到商品信息，请检查条码！', type: 'warning' })
          }
          this.scanbarcode = ''
          this.$nextTick(() => { this.$refs.scanbarcode.focus() })
        }).catch(() => {
          this.$message({ message: '扫码请求失败，请重试！', type: 'error' })
          this.scanbarcode = ''
          this.$nextTick(() => { this.$refs.scanbarcode.focus() })
        })
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          this.totalnumber = this.totalnumber + Math.abs(parseInt(this.tableData[i].totalnumber))
        }
      },
      //输入数量变化时处理：负数自动转正数
      handleNumberChange(row) {
        let val = parseInt(row.totalnumber)
        if (isNaN(val)) val = 0
        //输入负数自动转为正数
        row.totalnumber = Math.abs(val)
        this.totalNumber()
      },
      jingjiaupload() {
        if (this.controlData.pcustomerserial&&this.controlData.cangkucode && this.form.seedcode && this.form.seedcode.length >= 9) {
          this.$refs.fileupload.value = ""
          this.$refs.fileupload.click()
        } else {
          this.$message({
            message: '请先选择仓库、商品类别、供应商！',
            type: 'warning'
          });
        }
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
              var catename = this.pingpainame +this.form.seedname.replace(this.pingpainame, '')
              let arr = loadSpecFrame(data, this.form.seedcode, catename);
              if (arr.length > 0) {
                var loadTable=[]
                var addTable=[]
                var modelList = '';
                for (var i in arr) {
                  if (arr[i].minnumber == 0) {//没填写数量的不导
                    continue;
                  }

                  if (arr[i].costprice && parseFloat(arr[i].costprice) > 0) {//统一供应商名称
                    arr[i].relatedcategoryname = this.controlData.pcustomer;
                  }

                  var MandC = JSON.parse(arr[i].goodsframe)[0];

                  var hasColor = false;
                  //检查是否存在
                  for (let j in this.seedcodeData) {
                    if (this.seedcodeData[j].model == MandC.model) {//有型号

                      if ((';' + this.seedcodeData[j].color + ';').indexOf(';' + MandC.color + ';') > -1) {
                        hasColor = true;

                       loadTable.push({
                          seedcode: this.seedcodeData[j].seedcode,
                          seedname: this.seedcodeData[j].seedname,
                          color: MandC.color,
                          model: MandC.model,
                          categorycode: this.seedcodeData[j].categorycode,
                          totalnumber: arr[i].minnumber
                        });
                        break;
                      }
                      //已有的商品不导价格
                      // arr[i].seedcode = this.seedcodeData[j].seedcode
                      // arr[i].costprice = 0
                      // arr[i].refsellprice = 0
                      // arr[i].discountdetail = '[]'
                      // arr[i].relatedcategoryname = ''

                    }
                  }

                  if (!hasColor) {
                    modelList += MandC.model+ "-" +MandC.color + "、"
                    //addTable.push(arr[i]);//需要更新商品
                  }
                }

                if(loadTable.length>0){
                  this.afterSelectCode(loadTable);
                }
                if(modelList){
                  this.$message.error("型号-色号：" + modelList + " 在商品库中不存在，未导入！！")
                }
                if(addTable.length>0){

                  var goods=''

                  for(let i in addTable) {
                    var gf = JSON.parse(addTable[i].goodsframe)[0];
                    goods += (goods ? ' 、 ' : '') + gf.model + '-' + gf.color
                  }

                  const h = this.$createElement;
                  this.$msgbox({
                    title: '以下商品不存在，是否增加到商品库？',
                    message: goods,
                    showCancelButton: true,
                    closeOnClickModal:false,
                    confirmButtonText: '确定增加',
                    cancelButtonText: '取消',
                    beforeClose: (action, instance, done) => {
                      if (action === 'confirm') {
                        //先补录产品
                        jingjiaupload({arr: JSON.stringify(addTable)}).then(response => {
                          if (response.data.code == 0) {
                            var returnSeed = response.data.obj;
                            if (returnSeed == null) returnSeed = [];

                            loadTable = [];
                            for (let i in addTable) {

                              //补商品编码
                              if (!addTable[i].seedcode) {
                                for (let j in returnSeed) {
                                  if (returnSeed[j].goodsframe == addTable[i].goodsframe) {
                                    addTable[i].seedcode = returnSeed[j].seedcode
                                    addTable[i].seedname = returnSeed[j].seedname
                                    break;
                                  }
                                }
                              }

                              var gf = JSON.parse(addTable[i].goodsframe)[0];
                              loadTable.push({
                                seedcode: addTable[i].seedcode,
                                seedname: addTable[i].seedname,
                                color: gf.color,
                                model: gf.model,
                                categorycode: addTable[i].categorycode,
                                totalnumber: addTable[i].minnumber
                              });

                            }
                            if(loadTable.length>0){
                              //重新拉取型号
                              listgoodsframe({
                                categorycode: this.form.seedcode,
                                filltemplate: '80',
                              }).then(resGoods => {
                                this.seedcodeData = resGoods.data.obj
                              });

                              this.afterSelectCode(loadTable);
                            }
                          }
                          done();
                        });
                      } else {
                        done();
                      }
                    }
                  }).then(action => {
                    // this.$message({
                    //   type: 'info',
                    //   message: 'action: ' + action
                    // });
                  });

                }
              }
            }
          )
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      afterSelect(arr){
        for (var i in arr) {
          var hasValue = false;
          //数量取绝对值，确保显示为正数
          let qty = Math.abs(parseInt(arr[i].P))
          for (var j in this.tableData) {
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].M && this.tableData[j].color == arr[i].C)
            {//在库存里的
              this.tableData[j].totalnumber+=qty;
              hasValue = true
              break;
            }
          }
          if (!hasValue) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].C,
              model:arr[i].M,
              categorycode: arr[i].categorycode,
              totalnumber: qty,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].M+'","C":"'+arr[i].C+'"}',
              onlycode:'',
              barcodes:[]
            })
          }
        }
        this.sortTable();
        this.totalNumber();
      },
      sortTable(){
        //从小到大排序
        this.tableData.sort(function (a, b){
          if (a.model == b.model)
            return a.color.localeCompare(b.color);
          else
            return a.model.localeCompare(b.model);
        });
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.seedcodeData.length == 0) {
          this.$message.error("请先选择商品分类");
          return
        }
        for (let i in this.seedcodeData) {
          this.seedcodeData[i].totalnumber = 0
        }
        //参数  true 显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品
        this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.controlData.cangkucode, this.seedcodeData, this.controlData.pcustomerserial)
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          //数量取绝对值，确保显示为正数
          let qty = Math.abs(parseInt(arr[i].totalnumber))
          for (let j in this.tableData) {
            //判读该商品是否属于
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].model && this.tableData[j].color == arr[i].color) {
              biaoji = 1
              this.tableData[j].totalnumber += qty;//更新数量
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].color,
              model:arr[i].model,
              categorycode: arr[i].categorycode,
              totalnumber: qty,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].model+'","C":"'+arr[i].color+'"}',
              onlycode:'',
              barcodes:[]
            })
          }
        }
        this.sortTable();
        this.totalNumber()
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      //页面标题
      getTitle() {
        let result = this.userInfoModel.tenantname || ""
        result += this.isReturnOrder ? "采购退货单" : "采购订单"
        return result
      },
      customerInitSSO() {
        // this.ssotoken = ""
        // for (let i in this.ptableData) {
        //   if (this.ptableData[i].customerserial == this.controlData.pcustomerserial) {
        //     if(this.ptableData[i].usesso==1&&this.ptableData[i].ssocode){
        //       login({idencode: this.ptableData[i].ssocode, tenantid: this.userInfoModel.tenantid}).then(loginres => {
        //         if (loginres.data.code == 0) {
        //           this.ssotoken = loginres.data.msg;
        //           this.website=loginres.data.website;
        //         } else {
        //           this.$message({message: loginres.data.msg,type: 'error'})
        //         }
        //       });
        //     }
        //     break;
        //   }
        // }
      },
      changepcu(val) {
        this.ssotoken = ""
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == val) {
            this.controlData.pcustomerserial = this.ptableData[i].customerserial
            this.controlData.pcustomer = this.ptableData[i].deptname
            // this.controlData.clinkman = this.ptableData[i].linkman
            // this.controlData.clinkmantel = this.ptableData[i].linkmantel
            // this.controlData.caddress = this.ptableData[i].address
            this.customerInitSSO();
          }
        }
      },
      checktree1(guids, names, arr) {
        this.seedcodeData = []
        this.form.seedcode = guids
        this.form.seedname = names
        this.form.seedinfo = guids ;
        //仓库入口：类别选中后扫码框出现，自动聚焦
        if (!this.frombuy) {
          this.$nextTick(() => {
            if (this.$refs.scanbarcode) this.$refs.scanbarcode.focus()
          })
        }
        if(guids.length<=9){
          this.pingpainame=names;
        }else {
          this.pingpainame = this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3)).label;
        }

        if (this.form.seedname == "") {
          this.$message({
            message: '请选择类别',
            type: 'warning'
          })
          return
        }
        listgoodsframe({
          categorycode: this.form.seedcode,
          filltemplate: '80',
        }).then(response => {
          this.seedcodeData = response.data.obj
          if (this.seedcodeData.length > 0) {
            for (let i in this.seedcodeData) {
              this.seedcodeData[i].totalnumber = 0
            }
            if (!this.noeditpage && this.frombuy)
              this.addGood();
            this.geterweibiao();
          } else {
            this.$message({
              message: '该系列没有备货商品',
              type: 'warning'
            })
            return
          }

        }).catch((error) => {
          console.log(error)
        });

      },
      //判断是否有供应商
      geterweibiao() {
        this.ssotoken = ""
        var row={categorycode: this.form.seedcode, search: ""};
        if(this.enableddetail) {
          var seedcodes = [];
          for (let i in this.tableData) {
            seedcodes.push(this.tableData[i].seedcode);
          }
          row.seedcodes = JSON.stringify(seedcodes);
        }
        suppliers(row).then((response) => {
          this.ptableData = response.data.obj
          if (this.ptableData.length > 0) {
            this.pcustomerserial = this.ptableData[0].customerserial
            this.controlData.pcustomerserial = this.ptableData[0].customerserial
            this.controlData.pcustomer = this.ptableData[0].deptname
            // this.controlData.clinkman = this.ptableData[0].linkman
            // this.controlData.clinkmantel = this.ptableData[0].linkmantel
            // this.controlData.caddress = this.ptableData[0].address
            //参数  true 显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品
            //this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.controlData.cangkucode, this.seedcodeData, this.controlData.pcustomerserial);

            this.customerInitSSO();
          }

        })
      },

      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1,filltemplates:'80',hideseed:'1'})
        })

      },
      //备注格式化
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)

          this.showtitle1 = "none"
        })
      },
      show(frombuy, isReturnOrder) {
        this.frombuy=frombuy;
        this.isReturnOrder = !!isReturnOrder;
        this.dialogSeeVisible = true;
      },
      //仓库选择后获取仓库名
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
      },

      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },

      openQRCode(arr,erpserial) {
        var arrGood = []
        for (let i in arr) {
          var row = arr[i];
          arrGood.push({
            "inordernum": erpserial,
            "cangkucode": this.controlData.cangkucode,
            "seedcode": row.seedcode,
            "seedname": row.seedname,
            "packagesize": row.packagesize,
            "number": row.P
          });
        }
        this.$refs.QRCodeCreate1.show(erpserial, false, false, arrGood);
      },
      savePrint(showQRCode){
        this.showQRCode=showQRCode;
        this.saveData();
      },
      saveData() {
        //取出对应的表单详情和数量
        var arr = [];
        var barcodes=[];
        if (!this.controlData.pcustomerserial) {
          this.$message({
            message: '请选择供应商！',
            type: 'warning'
          })
          return
        }
        if (!this.controlData.cangkucode) {
          this.$message({
            message: '请选择仓库！',
            type: 'warning'
          })
          return
        }
        var seedcodelist=';'
        this.subnumber=0;
        for (let i in this.tableData) {
          if (this.tableData[i].totalnumber != 0) {

            if(seedcodelist.indexOf(';'+this.tableData[i].seedcode+';')==-1)
              seedcodelist+=this.tableData[i].seedcode+';';

            //退货模式下数量转为负数提交
            let submitQty = this.isReturnOrder ? -Math.abs(parseInt(this.tableData[i].totalnumber)) : parseInt(this.tableData[i].totalnumber)
            arr.push({
              seedcode: this.tableData[i].seedcode,
              seedname: this.tableData[i].seedname,
              P: submitQty,
              formproperty: '[{}]',
              packagesize:this.tableData[i].packagesize,
            })
            this.subnumber+=Math.abs(this.tableData[i].totalnumber);

            if(this.tableData[i].barcodes.length>0&&parseInt(this.tableData[i].totalnumber)!=this.tableData[i].barcodes.length){
              this.$message({
                message: '填写的数量和扫码数量不一致！',
                type: 'error'
              })
              return
            }

            for (let j in this.tableData[i].barcodes) {
              var item=this.tableData[i].barcodes[j];
              barcodes.push({
                storegoodsbarcode: item.storegoodsbarcode,
                seedcode: this.tableData[i].seedcode,
                packagesize:this.tableData[i].packagesize
              })
            }

          } else {
            this.$message({
              message: this.tableData[i].seedname + ',没有填写数量！',
              type: 'warning'
            })
            return
          }
        }
        if (arr.length <= 0) {
          this.$message({
            message: '请选择商品！',
            type: 'warning'
          })
          return
        }


        if (false&&this.ssotoken) {//需要向供应商发起采购
        } else {
          this.postBuyData(arr, '保存成功！',seedcodelist,barcodes);
        }
      },
      postBuyData(arr, msg,seedcodelist,barcodes) {
        this.loading = true
        var maprow= {
          pcustomerserial: this.controlData.pcustomerserial,
          pcustomer: this.controlData.pcustomer,
          cangkuname: this.controlData.cangkuname,
          cangkucode: this.controlData.cangkucode,
          address: '',
          linkman: '',
          linkmantel: '',
          seedcode: this.form.seedcode,
          seedname: this.form.seedname,
          seedinfo: this.form.seedinfo,
          remark: this.controlData.remark ? this.controlData.remark : '',
          tracknum: this.tracknum.trim(),//供应商单号
          isdistribute: this.frombuy ? '88' : '80',//镜架仓库录入的入库单
          logisticstracknum: this.logisticstracknum.trim(),//跟踪单号
          invoicesource: this.framebuyordernoaudit,//待审核
          status: 810,
          seedcodelist: seedcodelist,
          barcodes: JSON.stringify(barcodes),
        };
        if(this.relationserial){
          maprow.relationserial=this.relationserial;
        }
        buyodersavedetail({
          jxcforms: JSON.stringify(arr),
          map: JSON.stringify(maprow)
        }).then(response => {
          if (response.data.code == 0) {
            // if (this.ssotoken) {
            //   SSOrelatedOrder({
            //     erpserial: this.tracknum.trim(), parenterpserial: response.data.obj.erpserial, uname: '采购号'
            //   }, this.ssotoken).then(response => {
            //   })
            // }

            this.$message({
              message: msg,
              type: 'success'
            })
            this.$emit('bindGrid',response.data.obj);
            if (this.showQRCode)
              this.openQRCode(arr,response.data.obj.erpserial);

            //记录日志
            var handlelog = {}
            handlelog.erpserial = response.data.obj.erpserial
            handlelog.isopen = 1
            handlelog.insub = 1;
            handlelog.totalnumber = this.subnumber;
            handlelog.casestepname = this.isReturnOrder ? '采购退货' : '采购入库'
            handlelog.remark = ''
            saveLogData(handlelog).then(response => {
            });

            //未配置采购审核时，仓库待收货入口直接调确认入库（唯一码已入库，无需重复提交）
            if (!this.needAudit && !this.isReturnOrder && !this.frombuy) {
              updatebuyorder({
                unitguid: response.data.obj.unitguid,
                tracknum: this.tracknum.trim(),
                logisticstracknum: this.logisticstracknum.trim(),
                warehouse: '',
                warehousename: '',
                scancodes: '[]'
              }).then(updateRes => {
                if (updateRes.data.code == 0) {
                  this.$message({ message: '已自动确认入库', type: 'success' })
                  this.$emit('bindGrid')
                } else {
                  this.$message({ message: '自动入库失败：' + (updateRes.data.msg || ''), type: 'error' })
                }
              })
            }

            //this.lookbuyorderdetail(response.data.obj, 1)
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.loading = false
          }
          this.dialogSeeVisible = false;
          //刷新列表
        });
      },
      initData(row) {
        this.initForm();
        if (row == null)
          return;
        this.controlData.cangkucode = row.cangkucode;
        this.controlData.cangkuname = row.cangkuname;
        if (row.categorycode) {
          this.noeditpage = row.noeditpage;
          if (this.noeditpage)
            this.enableddetail = row.enableddetail;
          if (row.goodsdetail && row.goodsdetail.length > 0) {
            this.tableData = row.goodsdetail;
          }
          if (row.saleerpserial) {
            if (this.enableddetail)//全单采购,直接捆绑 销售单
              this.relationserial = row.saleerpserial;
            else {
              this.controlData.remark = row.saleerpserial;
              this.logisticstracknum = row.saleerpserial;
            }
          }
          this.checktree1(row.categorycode, row.categoryname);
        }
      },
      CurentTime() {
        var now = new Date();

        var year = now.getFullYear();       //年
        var month = now.getMonth() + 1;     //月
        var day = now.getDate();            //日

        var hh = now.getHours();            //时
        var mm = now.getMinutes();          //分

        var clock = year + "-";

        if (month < 10)
          clock += "0";

        clock += month + "-";

        if (day < 10)
          clock += "0";

        clock += day + " ";

        if (hh < 10)
          clock += "0";

        clock += hh + ":";
        if (mm < 10) clock += '0';
        clock += mm;
        return (clock);
      },
      initForm() {
        this.noeditpage=false;
        this.enableddetail=false;
        this.pcustomerserial=''
        this.ptableData=[]
        this.form.seedname=''
        this.form.seedcode=''
        this.index = -99
        this.form.seedinfo = ''
        this.controlData.pcustomerserial = '';
        this.controlData.pcustomer ='';
        this.controlData.remark='';
        this.groupguid = ""
        this.column = []
        this.ssotoken = ""
        this.tableData = []
        this.unitguid = ""
        this.tracknum = ''
        this.logisticstracknum = ''
        this.loading = false
        this.totalnumber = 0
        this.relationserial='';
        this.scanbarcode = ''
      }
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      if (temp) {
        this.userInfoModel = JSON.parse(temp);
      }
      checkModuleRight({name: 'framebuyordernoaudit'}).then(reponse => {//镜架采购单不需要审核
        this.framebuyordernoaudit = reponse.data.code == 0?'2':'1';
      });
      checkModuleRight({name: 'auditbuyorder'}).then(reponse => {//采购单需要审核
        this.needAudit = reponse.data.code == 0; //配置了则需要审核，未配置则直接入库
      });
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        this.controlData.cangkucode = this.jxcstoreData[0].cangkucode;
        this.controlData.cangkuname = this.jxcstoreData[0].cangkuname;
      })

    },

    components: {
      BatchBuyFormProperties,
      BuyfromSupplyer,
      MakeInventoryFrameAdd,
      QRCodeCreate
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BatchBuyorderDetailEdit.vue